import { ConfigProvider, Flex } from 'antd';
import { DrawingSetListPage, DrawingSetPage, InspectorWrapper, store } from '@sitemax/smx-drawings-web';
import { Provider } from 'react-redux';
import { useAppSelector } from '../../../../utilities/hooks';

const DrawingSetListWrapperPage = () => {
    const globalFilterProject = useAppSelector((state) => state.app.globalFilterProject);

    return (
        <Flex vertical flex={1} style={{ minWidth: 0, height: '100%' }}>
            <Flex justify={'space-between'}>
                <Provider store={store}>
                    <ConfigProvider
                        theme={{
                            components: {
                                Collapse: {
                                    headerPadding: '12px 16px',
                                },
                                Tabs: {
                                    horizontalMargin: '0 0 16px 0',
                                },
                            },
                        }}
                    >
                        <DrawingSetListPage filterProject={globalFilterProject} />
                        <InspectorWrapper filterProject={globalFilterProject} />
                    </ConfigProvider>
                </Provider>
            </Flex>
        </Flex>
    );
};

export default DrawingSetListWrapperPage;
